"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manageWorkspace = void 0;
var qs_1 = require("qs");
exports.manageWorkspace = function (axios) { return ({
    getWorkspaceInquiries: function (request) {
        var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
        return axios.get("/inquiries?" + query);
    },
    postWorkspaceInquiries: function (request) {
        return axios.post('/inquiries', request.data);
    },
    getWorkspaceInquiryTypes: function (request) {
        return axios.get('/inquiry-types');
    },
    getWorkspaceInquiriesInquiryNo: function (request) {
        var inquiryNo = request.pathParams.inquiryNo;
        return axios.get("/inquiries/" + inquiryNo);
    },
    putWorkspaceInquiriesInquiryNo: function (request) {
        var inquiryNo = request.pathParams.inquiryNo;
        return axios.put("/inquiries/" + inquiryNo, request.data);
    },
    deleteWorkspaceInquiriesInquiryNo: function (request) {
        var inquiryNo = request.pathParams.inquiryNo;
        return axios.delete("/inquiries/" + inquiryNo);
    },
    getWorkspaceBoardsBoardNoCategories: function (request) {
        var boardNo = request.pathParams.boardNo;
        return axios.get("/boards/" + boardNo + "/categories");
    },
    getWorkspaceBoardsBoardNoPosts: function (request) {
        var boardNo = request.pathParams.boardNo;
        var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
        return axios.get("/boards/" + boardNo + "/posts?" + query);
    },
    postWorkspaceBoardsBoardNoPosts: function (request) {
        var boardNo = request.pathParams.boardNo;
        return axios.post("/boards/" + boardNo + "/posts", request.data);
    },
    getWorkspaceBoardsBoardNoPostsPostNo: function (request) {
        var _a = request.pathParams, boardNo = _a.boardNo, postNo = _a.postNo;
        return axios.get("/boards/" + boardNo + "/posts/" + postNo);
    },
    putWorkspaceBoardsBoardNoPostsPostNo: function (request) {
        var _a = request.pathParams, boardNo = _a.boardNo, postNo = _a.postNo;
        return axios.put("/boards/" + boardNo + "/posts/" + postNo, request.data);
    },
    deleteWorkspaceBoardsBoardNoPostsPostNo: function (request) {
        var _a = request.pathParams, boardNo = _a.boardNo, postNo = _a.postNo;
        return axios.delete("/boards/" + boardNo + "/posts/" + postNo);
    },
    postWorkspaceBoardsBoardNoPostsPostNoRecommend: function (request) {
        var _a = request.pathParams, boardNo = _a.boardNo, postNo = _a.postNo;
        return axios.post("/boards/" + boardNo + "/posts/" + postNo + "/recommend");
    },
    deleteWorkspaceBoardsBoardNoPostsPostNoRecommend: function (request) {
        var _a = request.pathParams, boardNo = _a.boardNo, postNo = _a.postNo;
        return axios.delete("/boards/" + boardNo + "/posts/" + postNo + "/recommend");
    }
}); };
